export default __webpack_public_path__ + "static/meet-john-2-ac62872ec50a9e2ccdc716d6b52f7032.webp";